/**
 * Coerces heterogeneous job-record fields (Algolia / crawled JSON) into string[] for list UI.
 * Prevents `value.slice(0, n).map(...)` from running on strings (slice returns string → no .map).
 */
export function normalizeToStringArray(raw: unknown): string[] {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw.map((x) => String(x).trim()).filter(Boolean);
  }
  if (typeof raw === 'string') {
    const s = raw.trim();
    if (!s) return [];
    if (s.includes(',')) {
      return s.split(',').map((p) => p.trim()).filter(Boolean);
    }
    return [s];
  }
  return [];
}
